import React from 'react';

function AlignLeft({ children, ...rest }) {
  return (
    <div {...rest} style={{ marginRight: 'auto' }}>
      {children}
    </div>
  );
}

export default AlignLeft;
